import { muiTheme } from "@/styles/theme";
import { Box, Typography } from "@mui/material";
import { useState } from "react";

import EditLeadType from "@/modules/lead-page/components/lead-info/lead-type/edit-lead-type";
import { LeadTypeOption } from "@/modules/lead-page/constants";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
const TypeCorrection = () => {
  const [typeCorrectionModal, setTypeCorrectionModal] =
    useState<boolean>(false);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.xs,
          padding: nawyTheme.nawy.spacing.xs,
          alignItems: "center",

          cursor: "pointer",
          ":hover": {
            backgroundColor:
              muiTheme.colorSchemes.light.palette.main.actionDisabled,
          },
        }}
        onClick={() => setTypeCorrectionModal(true)}
      >
        <Typography
          sx={{
            color: nawyTheme.nawy.colors.semantic.text.primary,
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          Type correction, keep lead with the same user
        </Typography>
      </Box>

      <EditLeadType
        optionId={LeadTypeOption.TypeCorrection}
        modalOpen={typeCorrectionModal}
        setModalOpen={setTypeCorrectionModal}
      />
    </>
  );
};

export default TypeCorrection;
